import React from 'react';
import { Stack, IconButton, Image } from '@fluentui/react';

export interface FaviconRenderProps {
    favicon?: string;
    failedFavicons: Set<string>;
    onFaviconError: (faviconUrl: string) => void;
    size?: 'small' | 'medium' | 'large';
}

export const renderFavicon = ({ favicon, failedFavicons, onFaviconError, size = 'large' }: FaviconRenderProps): JSX.Element => {
    let imageSize: number;
    let containerSize: number;
    let iconSize: number;
    let borderRadius: number;

    switch (size) {
        case 'small':
            imageSize = 12;
            containerSize = 32;
            iconSize = 18;
            borderRadius = 1;
            break;
        case 'medium':
            imageSize = 24;
            containerSize = 32;
            iconSize = 18;
            borderRadius = 2;
            break;
        case 'large':
        default:
            imageSize = 64;
            containerSize = 64;
            iconSize = 24;
            borderRadius = 4;
            break;
    }

    if (!favicon || failedFavicons.has(favicon)) {
        return (
            <Stack
                horizontalAlign="center"
                verticalAlign="center"
                style={{
                    width: containerSize,
                    height: containerSize,
                    borderRadius: '50%',
                    background: '#7356fa1a',
                    marginRight: 4,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <IconButton
                    iconProps={{ iconName: 'Globe' }}
                    styles={{ root: { color: '#7356fa', fontSize: iconSize, background: 'none', cursor: 'pointer' } }}
                    disabled
                />
            </Stack>
        );
    }

    return <Image src={favicon} width={imageSize} height={imageSize} styles={{ root: { borderRadius } }} onError={() => onFaviconError(favicon)} />;
};
